import { LocalDate, LocalTime } from '@js-joda/core'

export enum FilterType {
  Location = 'Location',
  Date = 'Date',
  Department = 'Department',
  AdvancedFilters = 'Advanced Filters',
  UserGroup = 'User Group',
  UserType = 'User Type',
}

/**
 * Used as a form control name as well as a query string key.
 * Try to keep them short to save some characters in the URL.
 */
export enum FilterKey {
  Courthouse = 'c',
  Courtroom = 'cr',
  Department = 'd',
  DateFrom = 'dtf',
  DateTo = 'dtt',
  DateCountInterval = 'dtci',
  DurationFrom = 'df',
  DurationTo = 'dt',
  TimeFrom = 'tf',
  TimeTo = 'tt',
  Tags = 't',
  ReporterLocation = 'r',
  UserGroup = 'ug',
  UserType = 'ut',
  OnTheRecordContent = 'otr',
}

export enum FilterDateCountInterval {
  Month = 'month',
  Relative = 'PT',
  Day = 'day',
  DayRange = 'dayRange',
}

export type FilterValueData = Partial<Record<FilterKey, string | number | string[] | LocalTime | LocalDate | boolean>>

export interface FilterDescriptor {
  label: string
  subLabel?: string
}

export type FilterLabelData = Partial<Record<FilterType, FilterDescriptor>>

export interface FilterStateModel {
  labels: FilterLabelData
  values: FilterValueData
}

export enum RelativeDateRangeKey {
  Today = 'PT24H',
  Yesterday = 'PT24H#1',
  ThisWeek = 'PT168H',
  LastWeek = 'PT168H#7',
}

export interface ListFilterData {
  values: FilterValueData
  labels?: FilterLabelData
  generateLabelTypes?: FilterType[]
}
